import { ExampleDoubleDetailComponent } from './example-double-detail/example-double-detail.component';
import { ExampleDetail } from '../../models/example-detail.model';
import { Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { DataAction } from '../../../enum/data-action.enum';
import { ExampleService } from '../../services/example.service';
import { Subject, Observable, takeUntil, of, lastValueFrom, switchMap, map } from 'rxjs';
import { ExampleData } from '../../models/example-data.model';
import { Option } from '../../../models/option.model';
import { ExampleMaster } from '../../models/example-master.model';
import { Component } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { SimpleDoubleComponent } from '../../../components/abstract/simple/simple-double.component';
import { DialogReturnData } from '../../../models/dialog-return-data.model';

@Component({
  selector: 'app-example-double',
  templateUrl: './example-double.component.html',
  styleUrls: ['./example-double.component.scss']
})
export class ExampleDoubleComponent extends SimpleDoubleComponent {

  // Component 的 class 名稱
  override componentClassName: string = 'ExampleDoubleComponent';

  // Table 資料的 key 欄位名稱
  override rowDataKeyName: string = 'uuid';

  // Table 資料刪除時要取哪個欄位的值來顯示提示
  override rowDataDeleteHintFieldName: string = 'detailInput';

  // 為了寫程式可以點出提示，override 這個自行定義資料型別
  override masterData: ExampleMaster | undefined;

  // 為了寫程式可以點出提示，override 這個自行定義資料型別
  override detailDatas: ExampleDetail[] = [];

  // 為了寫程式可以點出提示，override 這個自行定義資料型別
  override rowCurrentData: ExampleDetail | undefined;

  // 下拉選單的 Options 資料
  exampleOptions: Option[] = [];

  // 動態下拉選單的 Options 資料
  dynamicOptions: Option[] = [];

  // 自動完成的 Suggestions 資料
  exampleDataSuggestions: ExampleData[] = [];
  // 自動完成欄位值變動的 Subject，用來避免前面一次查詢比較慢返回造成覆蓋資料
  private exampleDataSubject$ = new Subject<void>();

  // 自動完成 + 下拉的 Suggestions 資料
  allExampleData?: ExampleData[];
  // 自動完成 + 下拉的 Suggestions 資料
  allExampleDataSuggestions: ExampleData[] = [];
  // 自動完成 + 下拉欄位值變動的 Subject，用來避免前面一次查詢比較慢返回造成覆蓋資料
  private allExampleDataSubject$ = new Subject<void>();

  constructor(private exampleService: ExampleService) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    console.log('ExampleDoubleComponent ngOnInit');
  }

  override initFormGroup(): void {
    this.formGroup = this.formBuilder.nonNullable.group({
      id: '',
      uuid: '',
      input: ['', Validators.required],
      calendar: ['', Validators.required],
      dropdown: '',
      autoComplete: '',
      inputNumber: '',
      calendarRange: '',
      custValidation: ['', this.custValidator()],
      dynamicDropdown: '',
      autoCompleteDropdown: ''
    });
  }

  override initFormControlDisabled(): void {
    // 如果單頭表單欄位沒有特別需要控制不可編輯就不用寫
    return;
  }

  override initStaticOptions(): void {
    // 下拉選單選項
    this.exampleOptions = [
      {
        id: 'option.yes',
        label: this.translateService.instant('option.yes'),
        value: 'Y'
      },
      {
        id: 'option.no',
        label: this.translateService.instant('option.no'),
        value: 'N'
      }
    ];
  }

  override async initFormData(): Promise<any> {
    // 抓取 Master Data
    this.masterData = await lastValueFrom(this.loadMasterData());

    // 這只是為了範例程式用，因為範例程式沒有實際存到 DB，如果重新取資料會取不到，是正常的
    this.systemMessageService.warn('測試程式沒有實際把資料儲存到 DB，所以重新取資料會取不到是正常的');

    this.formGroup.patchValue({
      id: this.masterData?.id,
      uuid: this.masterData?.uuid,
      input: this.masterData?.input,
      calendar: this.masterData?.calendar,
      dropdown: this.masterData?.dropdown,
      inputNumber: this.masterData?.inputNumber,
      custValidation: this.masterData?.custValidation,
      dynamicDropdown: this.masterData?.dynamicDropdown
    });

    console.log('setMasterData = ' + JSON.stringify(this.formGroup.getRawValue()));

    await this.setDynamicOptions();
    await Promise.all([this.patchAutoComplete(), this.patchAutoCompleteDropdown()]);

    // 抓 Detail 資料
    this.detailDatas = await lastValueFrom(this.loadDetailData());
  }

  override afterFormDataLoadSuccess(): void {
    return;
  }

  override afterFormDataLoadFail(): void {
    return;
  }

  /**
   * 這裡應該是去取 uuid 重新查資料，或是直接拿前面傳入的資料來顯示，要自己判斷處理。
   * 為了統一處理的行為，建議都重新取資料比較一致，且資料會是最新的資料
   *
   * @returns
   */
  loadMasterData(): Observable<ExampleMaster> {
    console.log('ExampleDoubleComponent loadMasterData isDialogMode = ' + this.isDialogMode);

    // 為了統一處理的行為，建議都重新取資料比較一致，且資料會是最新的資料
    if (this.isDialogMode) {

      // 以下取 masterDataKeyValue 在 2023/08/13 取消，改在 BaseFormComponent 的 ngOnInit 就先取回。

      // 取出查詢 Master Data 的 Key
      // const data: ExampleMaster = this.dynamicDialogConfig.data;
      // const dataAction: DataAction = this.dynamicDialogConfig.data?.dataAction;

      // console.log('ExampleDoubleComponent loadMasterData dynamicDialogConfig = ' + JSON.stringify(this.dynamicDialogConfig));
      // console.log('ExampleDoubleComponent loadMasterData dataAction = ' + dataAction);

      // this.masterDataKeyValue = this.dynamicDialogConfig.data[this.masterDataKeyName];
    } else {
      this.masterDataKeyValue = this.activatedRoute.snapshot.paramMap.get(this.masterDataKeyName);
    }

    console.log('ExampleDoubleComponent loadMasterData uuid = ' + this.masterDataKeyValue);
    // 如果前面是做新增，而且沒有傳 key 的值，就產生一個空的
    if (this.parentDataAction == DataAction.NEW && !this.masterDataKeyValue) {
      let exampleMaster = new ExampleMaster();
      exampleMaster.id = DataAction.NEW;
      exampleMaster.uuid = uuidv4();
      return of(exampleMaster);
    } else {
      return this.exampleService.getExampleMasterData(this.masterDataKeyValue!).pipe(
        takeUntil(this._destroying$)
      );
    }
  }

  /**
   * 建議這些要在程式一開始前就取回來的東西分不同 function 處理
   */
  async setDynamicOptions(): Promise<void> {
    console.log('setDynamicOptions start');
    this.dynamicOptions = await lastValueFrom(
      this.exampleService.queryAllExampleDataOptions().pipe(takeUntil(this._destroying$))
    );
    console.log('setDynamicOptions end');
  }

  async patchAutoComplete(): Promise<void> {
    console.log('patchAutoComplete start');
    const keyword = this.masterData?.autoCompleteCode;
    if (keyword) {
      const data: ExampleData[] = await lastValueFrom(
        this.exampleService.queryExampleDatas(keyword).pipe(takeUntil(this._destroying$))
      );

      if (data.length > 0) {
        this.formGroup.patchValue({
          autoComplete: data.find(exampleData => exampleData.exampleDataCode == keyword)
        });
      } else {
        throw new Error('AutoComplete data ' + keyword + ' not found');
      }
    }
  }

  async patchAutoCompleteDropdown(): Promise<void> {
    console.log('patchAutoCompleteDropdown start');
    const keyword = this.masterData?.autoCompleteDropdownCode;
    if (keyword) {
      const data: ExampleData[] = await lastValueFrom(
        this.exampleService.queryExampleDatas(keyword).pipe(takeUntil(this._destroying$))
      );

      if (data.length > 0) {
        this.formGroup.patchValue({
          autoCompleteDropdown: data.find(exampleData => exampleData.exampleDataCode == keyword)
        });
      } else {
        throw new Error('AutoCompleteDropdown data ' + keyword + ' not found');
      }
    }
  }

  /**
   * 這裡應該是去取 uuid 重新查資料，或是直接拿前面傳入的資料來顯示，要自己判斷處理。
   * 為了統一處理的行為，建議都重新取資料比較一致，且資料會是最新的資料
   *
   * @returns
   */
  loadDetailData(): Observable<ExampleDetail[]> {
    // 因為單頭的 Key 值在 loadMasterData 的時候就取過了，這邊可以直接用
    console.log('ExampleDoubleComponent loadMasterData uuid = ' + this.masterDataKeyValue);
    // 如果前面是做新增，而且沒有傳 key 的值，就產生一個空的
    if (this.parentDataAction == DataAction.NEW && !this.masterDataKeyValue) {
      return of([]);
    } else {
      // 這裡應該傳 masterDataKeyValue 去查，因為傳 id 隨便人都可以改數字就抓到資料，
      // 這裡傳 id 只是因為我沒有後端程式可以處理，只是為了做取值範例
      return this.exampleService.getExampleDetailData(this.masterData?.id!).pipe(
        takeUntil(this._destroying$)
      );
    }
  }

  override initExtraMasterMenu(): void {
    this.masterMenu.push(
      {
        id: this.parseToId('btnMasterMenuOther'),
        label: '其他功能按鈕',
        automationId: '其他功能按鈕',
        command: () => {
          // 這裡應該去呼叫獨立寫的一個 function 做事情
          this.systemMessageService.info('按下其他功能按鈕');
        }
      },
      {
        id: this.parseToId('btnMasterMenuNoIcon'),
        label: '如果不能給有意義的 icon 就只放文字就好',
        command: () => {
          // 這裡應該去呼叫獨立寫的一個 function 做事情
          this.systemMessageService.info('按下如果不能給有意義的 icon 就只放文字就好');
        }
      }
    );
  }

  override setExtraMasterMenuStatus(): void {
    console.log('setExtraMasterMenuStatus');
    let masterMenuButtonOther = this.masterMenu.find(menuItem => menuItem.id == this.parseToId('btnMasterMenuOther'));
    if (masterMenuButtonOther) {
      masterMenuButtonOther.disabled = !this.masterInViewStatus();
    }

    let masterMenuButtonNoIcon = this.masterMenu.find(menuItem => menuItem.id == this.parseToId('btnMasterMenuNoIcon'));
    if (masterMenuButtonNoIcon) {
      masterMenuButtonNoIcon.disabled = !this.masterInViewStatus();
    }
  }

  override afterLangChange(): void {
    this.languageService.processOptionTranslation(this.exampleOptions);
  }

  override initExtraDetailMenu(): void {
    return;
  }

  override setExtraDetailMenuStatus(): void {
    return;
  }

  override initTableColumns(): void {
    this.tableColumns = [
      {
        header: '文字輸入',
        field: 'detailInput',
        sortable: true
      },
      {
        header: '選擇日期',
        field: 'detailCalendar',
        sortable: true
      },
      {
        header: '下拉選單',
        field: 'detailDropdown',
        translateArrayValue: {
          datas: this.exampleOptions,
          valueField: 'value',
          displayField: 'label'
        },
        sortable: true
      },
      {
        header: '自動完成',
        field: 'detailAutoCompleteName',
        translateDataValueField: 'detailAutoCompleteName',
        width: 180,
        sortable: true
      },
      {
        header: '數字輸入',
        field: 'detailInputNumber',
        numberField: true,
        sortable: true
      },
      {
        header: '動態下拉',
        field: 'detailDynamicDropdown',
        translateArrayValue: {
          datas: this.dynamicOptions,
          valueField: 'value',
          displayField: 'label'
        },

        width: 180,
        sortable: true
      },
      {
        header: '自訂欄位驗證',
        field: 'detailCustValidation'
      },
      {
        header: '自動完成+下拉',
        field: 'detailAutoCompleteDropdownName',
        translateDataValueField: 'detailAutoCompleteDropdownName',
        width: 180,
        sortable: true
      }
    ];
  }

  override initExtraRowActionMenu(): void {
    return;
  }

  override setExtraRowActionMenuStatus(): void {
    return;
  }

  override afterDetailTabActiveItemChange(): void {
    return;
  }

  override initDialogConfig(dataAction: DataAction): void {
    let dialogHeader: string = '';
    let dialogData: any = {};

    if (dataAction == DataAction.NEW) {
      dialogHeader = '功能標題新增資料';
    } else if (dataAction == DataAction.VIEW) {
      dialogHeader = '功能標題檢視資料';
      dialogData = this.rowCurrentData;
    } else if (dataAction == DataAction.EDIT) {
      dialogHeader = '功能標題編輯資料';
      dialogData = this.rowCurrentData;
    }

    this.dialogConfig = {
      component: ExampleDoubleDetailComponent,
      dataAction: dataAction,
      width: '80%',
      height: '70%',
      header: dialogHeader,
      data: dialogData
    };
  }

  override doExtraDetailDialogClose(returnData: DialogReturnData): void {
    return;
  }

  override afterSelectedRowDataCountChange(selectedDataCount: number): void {
    return;
  }

  override afterRowDataCountChange(rowDataCount: number): void {
    return;
  }

  override async doMasterMenuSubmit(): Promise<boolean> {
    return new Promise(resolve => {
      // TODO 實作存檔時要呼叫 API 存入資料，成功後記得要呼叫傳入的 callback function
      // setTimeout 是故意模擬處理的時間，實際上不會這樣做
      setTimeout(() => {

        let submitData: ExampleMaster = new ExampleMaster();
        // 存檔後如果 id 是 new 表示新增的資料，把 id 清空，之後才不會被判斷成是新增未存檔的資料
        submitData.id = this.formGroup.getRawValue().id != DataAction.NEW ? this.formGroup.getRawValue().id : '';
        submitData.uuid = this.formGroup.getRawValue().uuid;
        submitData.input = this.formGroup.getRawValue().input;
        submitData.calendar = this.formGroup.getRawValue().calendar;
        submitData.dropdown = this.formGroup.getRawValue().dropdown;
        submitData.autoCompleteCode = this.formGroup.getRawValue().autoComplete?.exampleDataCode;
        submitData.autoCompleteName = this.formGroup.getRawValue().autoComplete?.exampleDataName;
        submitData.autoCompleteNameTw = this.formGroup.getRawValue().autoComplete?.exampleDataNameTw;
        submitData.autoCompleteNameCn = this.formGroup.getRawValue().autoComplete?.exampleDataNameCn;
        submitData.autoCompleteNameUs = this.formGroup.getRawValue().autoComplete?.exampleDataNameUs;
        submitData.inputNumber = this.formGroup.getRawValue().inputNumber;
        submitData.calendarRange = this.formGroup.getRawValue().calendarRange;
        submitData.custValidation = this.formGroup.getRawValue().custValidation;
        submitData.dynamicDropdown = this.formGroup.getRawValue().dynamicDropdown;
        submitData.autoCompleteDropdownCode = this.formGroup.getRawValue().autoCompleteDropdown?.exampleDataCode;
        submitData.autoCompleteDropdownName = this.formGroup.getRawValue().autoCompleteDropdown?.exampleDataName;
        submitData.autoCompleteDropdownNameTw = this.formGroup.getRawValue().autoCompleteDropdown?.exampleDataNameTw;
        submitData.autoCompleteDropdownNameCn = this.formGroup.getRawValue().autoCompleteDropdown?.exampleDataNameCn;
        submitData.autoCompleteDropdownNameUs = this.formGroup.getRawValue().autoCompleteDropdown?.exampleDataNameUs;

        console.log('submitData = ' + JSON.stringify(submitData));

        // 單身的資料應可以直接從 this.detailDatas 取得
        console.log('submitData detailDatas = ' + JSON.stringify(this.detailDatas));

        this.systemMessageService.info('模擬實際存檔會花一點時間處理');
        // 儲存資料的時候要把資料也更新回 masterData

        // 儲存完資料後端應該要回傳儲存後的物件，然後要把它更新至 this.masterData
        // 因為有可能會儲存完又編輯，這時候會直接用 masterData 來維護
        this.masterData = submitData;

        if (this.formGroup.getRawValue().id == DataAction.NEW) {
          this.formGroup.patchValue({
            id: ''
          });
        }

        resolve(true);
      }, this.exampleService.delay);
    });
  }

  override async doMasterMenuDelete(): Promise<boolean> {
    return new Promise(resolve => {
      // TODO 實作刪除時要呼叫 API 刪除資料，成功後記得要呼叫傳入的 callback function
      // setTimeout 是故意模擬處理的時間，實際上不會這樣做
      setTimeout(() => {
        this.systemMessageService.info('模擬實際刪除會花一點時間處理');
        resolve(true);
      }, this.exampleService.delay);
    });
  }

  custValidator(): ValidatorFn {
    return (formControl: AbstractControl): ValidationErrors | null => {
      if (!formControl.parent) {
        return null;
      }

      // 欄位要做什麼驗證
      const error = formControl.parent?.get('custValidation')?.value == '1';

      // 如果有錯
      if (error) {
        // 回傳 ValidationErrors，duplicate 是 error 的 key
        return { duplicate: true };
      }
      // 驗證結果符合需求，回傳 null
      return null;
    }
  }

  searchExampleDataSuggestions(event: any) {
    // 這個訂閱不寫在最上面是希望讓自動完成欄位的程式集中在一起，比較好閱讀
    if (!this.exampleDataSubject$.observed) {
      this.exampleDataSubject$.pipe(
        switchMap(keyword => this.exampleService.queryExampleDatas(keyword!)),
        takeUntil(this._destroying$)
      ).subscribe(data => {
        this.exampleDataSuggestions = data;
        console.log('this.exampleDataSuggestions = ' + this.exampleDataSuggestions.length);
      });
    }

    this.exampleDataSubject$.next(event.query);
  }

  searchAllExampleDataSuggestions(event: any) {
    // 這個訂閱不寫在最上面是希望讓自動完成欄位的程式集中在一起，比較好閱讀
    if (!this.allExampleDataSubject$.observed) {
      this.allExampleDataSubject$.pipe(
        switchMap(keyword => {
          // 如果 allExampleData 已經有取過值了就用它，不然就呼叫 API 取
          let data: Observable<ExampleData[]> = this.allExampleData ? of(this.allExampleData) : this.exampleService.queryAllExampleDatas()
          return data.pipe(
            map(data => {
              // 把回傳所有的值塞到 allExampleData
              this.allExampleData = data;
              // 根據輸入的關鍵字過濾
              return data.filter(exampleData => exampleData.exampleDataName.indexOf(keyword!) >= 0)
            })
          );
        }),
        takeUntil(this._destroying$)
      ).subscribe(data => {
        this.allExampleDataSuggestions = data;
      });
    }

    this.allExampleDataSubject$.next(event.query);
  }
}
